import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { MenuService } from '../menu.service';
import { AuthService } from '@features/auth/auth.service';
import { AuthStore } from '@features/auth/store/auth.store';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'fc-menu-user',
  templateUrl: './menu-user.component.html',
  styleUrl: './menu-user.component.scss',
  providers: [MenuService],
  imports: [RouterModule, TranslocoModule, MatIconModule, MatButtonModule, MatMenuModule],
})
export class MenuUserComponent {
  private readonly menuService = inject(MenuService);
  private readonly authStore = inject(AuthStore);
  private readonly authService = inject(AuthService);

  readonly menuUser = this.menuService.getUserMenu();
  readonly user = this.authStore.user;

  logout(): void {
    this.menuService.closeMenu();
    this.authService.signOut().subscribe();
  }
}
